<template>
<div>
	<breadcrumb :items="breadcrumbs"></breadcrumb>
    <v-container fluid>
      	<v-form 
			ref="form"
			v-model="valid"
			lazy-validation
      		v-on:submit.prevent="updateFarm"
		>
        	<div class="page-title">
          		<h2>{{$t('farm.editFarm')}}</h2>
				<v-spacer></v-spacer>
          		<template>
            		<div class="mt-5 text-center data-drop">
						<v-menu
							bottom
							origin="center center"
							transition="scale-transition"
						>
							<template v-slot:activator="{ on, attrs }">
								<v-btn
								outlined
									:to="{ name: 'SingleFarm' }"
									v-bind="attrs"
									v-on="on"
									color="primary"
								>
								{{$t('farm.cancel')}}
								</v-btn>
								<v-btn
									color="primary"
									dark
									v-bind="attrs"
									v-on="on"
									type="submit"
								>
									{{$t('farm.update')}}
								</v-btn>
							</template>
              			</v-menu>
            		</div>
          		</template>
        	</div>
        	<div class="mt-2 form-section">
          		<v-card class="mb-2">
          			<v-container fluid>
          				<h3>{{$t('farm.farmInformation')}}</h3>
						<template>
              				<v-row class="mt-2">
								<v-col cols="12" sm="6" md="3">
									<label for="text">{{$t('farm.farmName')}} <span class="red--text">*</span>
										<v-tooltip top color="black" max-width="220">
											<template v-slot:activator="{ on, attrs }">
												<v-icon v-bind="attrs" v-on="on">
													mdi-information-outline
												</v-icon>
											</template>
											<span>{{$t('farm.farmNameH')}}</span>
										</v-tooltip>
									</label>
									<v-text-field
										v-model="farm.name"
										placeholder="Name of Farm"
										outlined
										dense
										:rules="farmRules.farmName"
									></v-text-field>
								</v-col>

								<v-col cols="12" sm="6" md="3">
									<label for="text">{{$t('farm.farmType')}}
										<v-tooltip top color="black" max-width="220">
											<template v-slot:activator="{ on, attrs }">
											<v-icon v-bind="attrs" v-on="on">
												mdi-information-outline
											</v-icon>
											</template>
											<span>{{$t('farm.farmTypeH')}}</span>
										</v-tooltip>
									</label>
									<v-select
										class="text-capitalize"
										v-model="farm.farmType"
										:items="farmType"
										placeholder="Farm Type"
										outlined
										dense
										:rules="farmRules.farmType"
										
									></v-select>
								</v-col>

                				<v-col cols="12" sm="6" md="3">
									<label for="text">{{$t('farm.farmOwner')}}
										<v-tooltip top color="black" max-width="220">
											<template v-slot:activator="{ on, attrs }">
												<v-icon v-bind="attrs" v-on="on">
													mdi-information-outline
												</v-icon>
											</template>
											<span>{{$t('farm.farmOwnerH')}}</span>
										</v-tooltip>
									</label>
									<v-text-field
										v-model="farm.ownerId"
										:placeholder="$t('farm.farmOwner')"
										outlined
										dense
									></v-text-field>
									<!-- <v-autocomplete
										v-model="farm.owner.userNumber"
									:items="ownerName"
									outlined
									dense
									class="text-capitalize"
									item-text="name"
									item-value="userNumber"
									placeholder="Type Owner Name"
									:rules="farmRules.ownerId"
									></v-autocomplete> -->
								</v-col>

								<v-col cols="12" sm="6" md="3">
									<label for="text">{{$t('farm.ownershipType')}}
										<v-tooltip top color="black" max-width="220">
											<template v-slot:activator="{ on, attrs }">
											<v-icon v-bind="attrs" v-on="on">
												mdi-information-outline
											</v-icon>
											</template>
											<span>{{$t('farm.ownershipTypeH')}}</span>
										</v-tooltip>
									</label>
									<v-select
										class="text-capitalize"
										:items="farmownershipType"
										placeholder="Ownership Type"
										outlined
										dense
										v-model="farm.farmOwnershipType"
										:rules="farmRules.farmOwnershipType"
									></v-select>
								</v-col>
								<v-col cols="12" sm="6" md="3" v-if="farm.farmOwnershipType === 'community'">
									<label for="text">{{$t('farm.communityName')}}</label>
									<v-text-field
										v-model="farm.communityName"
										:placeholder="$t('farm.communityName')"
										outlined
										dense
									></v-text-field>
								</v-col>

								<v-col cols="12" sm="6" md="3">
									<label>{{$t('farm.govRegistrationNo')}}
										<v-tooltip top color="black" max-width="220">
											<template v-slot:activator="{ on, attrs }">
											<v-icon v-bind="attrs" v-on="on">
												mdi-information-outline
											</v-icon>
											</template>
											<span>{{$t('farm.govtRegNumbH')}}</span>
										</v-tooltip>
									</label>
									<v-text-field
										placeholder="Govt Registration Number"
										outlined
										dense
										v-model="farm.govRegistrationNo"
										:rules="farmRules.govRegistrationNo"
										:error-messages="errors.govRegistrationNo"
									></v-text-field>
								</v-col>

								<v-col cols="12" sm="6" md="3">
									<label>{{$t('farm.contractMating')}}
										<v-tooltip top color="black" max-width="220">
											<template v-slot:activator="{ on, attrs }">
											<v-icon v-bind="attrs" v-on="on">
												mdi-information-outline
											</v-icon>
											</template>
											<span>{{$t('farm.contractMatingH')}}</span>
										</v-tooltip>
									</label>
									<v-text-field
										placeholder="Contract Mating"
										outlined
										dense
										v-model="farm.contractMating"
										:rules="farmRules.contractMating"
									></v-text-field>
								</v-col>

								<v-col cols="12" sm="6" md="3">
									<label>{{$t('farm.productionSystem')}}
										<v-tooltip top color="black" max-width="220">
											<template v-slot:activator="{ on, attrs }">
											<v-icon v-bind="attrs" v-on="on">
												mdi-information-outline
											</v-icon>
											</template>
											<span>{{$t('farm.productionSystemH')}}</span>
										</v-tooltip>
									</label>
									<v-select
										:items="productionSystem"
										class="text-capitalize"
										placeholder="Production System"
										outlined
										dense
										item-text="name"
										item-value="id"
										v-model="farm.productionSystem.id"
										:rules="farmRules.productionSystem"
									></v-select>
								</v-col>

								<v-col cols="12" sm="6" md="3">
									<label>{{$t('farm.cooperativeID')}}
										<v-tooltip top color="black" max-width="220">
											<template v-slot:activator="{ on, attrs }">
											<v-icon v-bind="attrs" v-on="on">
												mdi-information-outline
											</v-icon>
											</template>
											<span>{{$t('farm.cooperativeIDH')}}</span>
										</v-tooltip>
									</label>
									<v-text-field
										placeholder="Cooperative ID"
										outlined
										dense
										v-model="farm.cooperativeID"
										:rules="farmRules.cooperativeID"
									></v-text-field>
								</v-col>
              				</v-row>
          				</template>
          			</v-container>
          		</v-card>

        		<v-card class="mt-5 mb-5">
            		<v-container fluid>
          				<h3>{{$t('farm.farmLicenseInformation')}}</h3>
          				<template>
							<v-row class="mt-2">
								<v-col cols="12" sm="6" md="3">
									<label>{{$t('farm.licenseNumber')}}
										<v-tooltip top color="black" max-width="220">
											<template v-slot:activator="{ on, attrs }">
											<v-icon v-bind="attrs" v-on="on">
												mdi-information-outline
											</v-icon>
											</template>
											<span>{{$t('farm.licenseNumberH')}}</span>
										</v-tooltip>
									</label>
									<v-text-field
										placeholder="License Number"
										outlined
										v-model="farm.licenceNumber"
										:rules="farmRules.licenceNumber"
										dense
									></v-text-field>
								</v-col>

								<v-col cols="12" sm="6" md="3">
									<label>{{$t('farm.licenseExpiryDate')}}
										<v-tooltip top color="black" max-width="220">
											<template v-slot:activator="{ on, attrs }">
											<v-icon v-bind="attrs" v-on="on">
												mdi-information-outline
											</v-icon>
											</template>
											<span>{{$t('farm.licenseExpiryDateH')}}</span>
										</v-tooltip>
									</label>
									<v-menu
										ref="menu"
										v-model="menu"
										:close-on-content-click="false"
										:return-value.sync="date"
										dense
										transition="scale-transition"
										offset-y
										min-width="auto"
									>
										<template v-slot:activator="{ on, attrs }">
											<v-text-field
												v-model="farm.licenceED"
												placeholder="Choose the date"
												append-icon="mdi-calendar"
												outlined
												readonly
												dense
												v-bind="attrs"
												v-on="on"
												:rules="farmRules.licenceED"
												@click:append="menu = true"
											></v-text-field>
										</template>
										<v-date-picker v-model="farm.licenceED" no-title scrollabel :min="farm.licenceED || today">
											<v-spacer></v-spacer>
											<v-btn text color="primary" @click="menu = false" >
											{{$t('farm.cancel')}}
											</v-btn>
											<v-btn
												text
												color="primary"
												@click="$refs.menu.save(farm.licenceED)"
											>
											{{$t('farm.ok')}}
											</v-btn>
										</v-date-picker>
									</v-menu>
								</v-col>

								<v-col cols="12" sm="6" md="3">
									<label>{{$t('farm.regulatorName')}}
										<v-tooltip top color="black" max-width="220">
											<template v-slot:activator="{ on, attrs }">
											<v-icon v-bind="attrs" v-on="on">
												mdi-information-outline
											</v-icon>
											</template>
											<span>{{$t('farm.regularNameH')}}</span>
										</v-tooltip>
									</label>
									<v-text-field
										placeholder="Regulator Name"
										outlined
										dense
										v-model="farm.regulatorName"
										:rules="farmRules.regulatorName"
									></v-text-field>
								</v-col>

								<v-col cols="12" sm="6" md="3">
									<label>{{$t('farm.regulatorRepresentativeName')}}
										<v-tooltip top color="black">
											<template v-slot:activator="{ on, attrs }">
											<v-icon v-bind="attrs" v-on="on">
												mdi-information-outline
											</v-icon>
											</template>
											<span>{{$t('farm.regularRepName')}}</span>
										</v-tooltip>
									</label>
									<v-text-field
										placeholder="Regulator Representative Name"
										outlined
										dense
										v-model="farm.regulatorRepName"
										:rules="farmRules.regulatorRepName"
									></v-text-field>
								</v-col>
              				</v-row>
          				</template>
          			</v-container>
          		</v-card>

          		<!-- <v-card class="mt-5">
            		<v-container fluid>
          				<h3>{{$t('farm.farmLocationSize')}}</h3>
          					<template>
             	 				<v-row class="mt-2"> -->
									<!-- <v-col cols="12" sm="6" md="3">
										<label>Farm Geo-Fence</label>
										<v-text-field @click="$router.push({name: 'GoogleMap'})"
										placeholder="Farm geofence"
										outlined
										dense
										></v-text-field>
									</v-col> 
									<v-col cols="12" sm="6" md="3">
										<label>{{$t('farm.country')}} <span class="red--text">*</span>
										<v-tooltip top color="black" max-width="220">
											<template v-slot:activator="{ on, attrs }">
											<v-icon v-bind="attrs" v-on="on">
												mdi-information-outline
											</v-icon>
											</template>
											<span>{{$t('farm.countryH')}}</span>
										</v-tooltip></label>
										<v-select
										:items="country"
										placeholder="Country"
										outlined
										item-text="name"
										dense
										:loading="countryLoading"
										v-model="farm.country.id"
										@change="getStates(farm.country.id)"
										item-value="id"
										:rules="farmRules.country"
										></v-select>
									</v-col>

									<v-col cols="12" sm="6" md="3">
									<label>{{$t('farm.state')}} <span class="red--text">*</span>
										<v-tooltip top color="black" max-width="220">
											<template v-slot:activator="{ on, attrs }">
											<v-icon v-bind="attrs" v-on="on">
												mdi-information-outline
											</v-icon>
											</template>
											<span>{{$t('farm.stateH')}}</span>
										</v-tooltip>
									</label>
									<v-select
										:items="state"
										placeholder="State"
										outlined
										item-text="name"
										dense
										:loading="stateLoading"
										item-value="id"
										v-model="farm.state.id"
										@change="getCity(farm.state.id)"
										:rules="farmRules.state"
									></v-select>
									</v-col>

									<v-col cols="12" sm="6" md="3" v-if="farm.city!==null">
										<label>{{$t('farm.city')}}
											<v-tooltip top color="black">
												<template v-slot:activator="{ on, attrs }">
												<v-icon v-bind="attrs" v-on="on">
													mdi-information-outline
												</v-icon>
												</template>
												<span>{{$t('farm.city')}}</span>
											</v-tooltip>
										</label>
										<v-select
											:items="city"
											placeholder="City"
											outlined
											item-text="name"
											dense
											:loading="cityLoading"
											v-model="farm.cityId"
											item-value="id"
											:rules="farmRules.city"
										></v-select>
									</v-col> -->
									<!-- <v-col cols="12" sm="6" md="3">
										<label>{{$t('farm.city')}} <span class="red--text">*</span>
											<v-tooltip top color="black" max-width="220">
												<template v-slot:activator="{ on, attrs }">
												<v-icon v-bind="attrs" v-on="on">
													mdi-information-outline
												</v-icon>
												</template>
												<span>{{$t('farm.cityH')}}</span>
											</v-tooltip>
										</label>
										<v-select
											outlined
											dense
											:items="city"
											placeholder="City"
											item-value="id"
											item-text="name"
											:loading="cityLoading"
											v-model="farm.cityId"
											:rules="farmRules.city"
										></v-select>
									</v-col>

									<v-col cols="12" sm="6" md="3">
										<label>{{$t('farm.street')}}
											<v-tooltip top color="black" max-width="220">
												<template v-slot:activator="{ on, attrs }">
												<v-icon v-bind="attrs" v-on="on">
													mdi-information-outline
												</v-icon>
												</template>
												<span>{{$t('farm.streetH')}}</span>
											</v-tooltip>
										</label>
										<v-text-field
											:items="items"
											placeholder="Street"
											outlined
											dense
											v-model="farm.street"
											:rules="farmRules.street"
										></v-text-field>
									</v-col>
									<v-col cols="12" sm="6" md="3">
										<label>{{$t('farm.houseNumber')}}
											<v-tooltip top color="black" max-width="220">
												<template v-slot:activator="{ on, attrs }">
												<v-icon v-bind="attrs" v-on="on">
													mdi-information-outline
												</v-icon>
												</template>
												<span>{{$t('farm.houseNumberH')}}</span>
											</v-tooltip>
										</label>
										<v-text-field
											placeholder="House number "
											outlined
											dense
											v-model="farm.houseNo"
											>
										</v-text-field>
									</v-col>
									<v-col cols="12" sm="6" md="3">
										<label>{{$t('farm.totalFarmSize')}}
											<v-tooltip top color="black" max-width="220">
												<template v-slot:activator="{ on, attrs }">
												<v-icon v-bind="attrs" v-on="on">
													mdi-information-outline
												</v-icon>
												</template>
												<span>{{$t('farm.totalFarmSizeH')}}</span>
											</v-tooltip>
										</label>
										<v-layout row>
											<v-col cols="6">
											<v-text-field
												v-model="farm.farmSize"
												placeholder="Total Farm Size"
												outlined
												dense
												></v-text-field> -->
												<!-- :rules="farmRules.farmSize" -->
											<!-- </v-col>
											<v-col cols="6">
											<v-select
												v-model="farm.farmSizeUomId"
												:items="farmUni"
												placeholder="Select Unit"
												outlined
												class="text-capitalize"
												item-text="name"
												item-value="id"
												dense
											></v-select>
											</v-col>
										</v-layout>
									</v-col>
              					</v-row>
							</template>
            			</v-container>
				</v-card> -->

				<!-- <v-card class="mt-5">
					<v-container fluid>
						<h3>{{$t('farm.farmGeographicLocation')}}</h3>
						<template>
							<v-row class="mt-2">
								<v-col cols="12" sm="6" md="3">
									<label>{{$t('farm.farmLatitude')}}
										<v-tooltip top color="black" max-width="220">
											<template v-slot:activator="{ on, attrs }">
											<v-icon v-bind="attrs" v-on="on">
												mdi-information-outline
											</v-icon>
											</template>
											<span>{{$t('farm.farmLatitudeH')}}</span>
										</v-tooltip> 
									</label>
									<v-text-field
										placeholder="Outlined"
										outlined
										dense
										v-model="farm.lat"
										:rules="farmRules.lat"
									></v-text-field>
								</v-col>

								<v-col cols="12" sm="6" md="3">
									<label>{{$t('farm.farmLongitude')}}
										<v-tooltip top color="black" max-width="220">
											<template v-slot:activator="{ on, attrs }">
											<v-icon v-bind="attrs" v-on="on">
												mdi-information-outline
											</v-icon>
											</template>
											<span>{{$t('farm.farmLongitudeH')}}</span>
										</v-tooltip>
									</label>
									<v-text-field
										:items="items"
										placeholder="Farm Longitude"
										outlined
										dense
										v-model="farm.log"
										:rules="farmRules.log"
									></v-text-field>
								</v-col>

								<v-col cols="12" sm="6" md="3">
									<label>{{$t('farm.perimeterLength')}}
										<v-tooltip top color="black" max-width="220">
											<template v-slot:activator="{ on, attrs }">
											<v-icon v-bind="attrs" v-on="on">
												mdi-information-outline
											</v-icon>
											</template>
											<span>{{$t('farm.perimeterLengthH')}}</span>
										</v-tooltip>
									</label>
									<v-layout row>
										<v-col cols="6">
											<v-text-field
												placeholder="Perimeter Length"
												outlined
												dense
												v-model="farm.farmPerimeter"
											></v-text-field>
										</v-col>
										<v-col cols="6">
											<v-select
												:items="periUni"
												item-text="name"
												item-value="id"
												placeholder="Select Unit"
												outlined
												dense
												class="text-capitalize"
												v-model="farm.farmPerimeterUomId"
											></v-select>
										</v-col>
									</v-layout>
								</v-col>

								<v-col cols="12" sm="6" md="3">
									<label>{{$t('farm.perimeterPointLabel')}}
										<v-tooltip top color="black" max-width="220">
											<template v-slot:activator="{ on, attrs }">
											<v-icon v-bind="attrs" v-on="on">
												mdi-information-outline
											</v-icon>
											</template>
											<span>{{$t('farm.perimeterPointLabelH')}}</span>
										</v-tooltip>
									</label>
									<v-text-field
										placeholder="Perimeter Point Label"
										outlined
										dense
										v-model="farm.periPointLabel"
									></v-text-field>
								</v-col>
								<v-col cols="12" sm="6" md="3">
									<label>{{$t('farm.perimeterPointLatitude')}}
										<v-tooltip top color="black" max-width="220">
											<template v-slot:activator="{ on, attrs }">
											<v-icon v-bind="attrs" v-on="on">
												mdi-information-outline
											</v-icon>
											</template>
											<span>{{$t('farm.perimeterPointLatH')}}</span>
										</v-tooltip>
									</label>
									<v-text-field
										placeholder="Perimeter Point Latitude"
										outlined
										dense
										v-model.number="farm.periPointLat"
										:rules="[
											v => ( !v || validateLatLng(v)) || 'Invalid Latitude'
										]"
									></v-text-field>
								</v-col>
								<v-col cols="12" sm="6" md="3">
									<label>{{$t('farm.perimeterPointLongitude')}}
										<v-tooltip top color="black" max-width="220">
											<template v-slot:activator="{ on, attrs }">
											<v-icon v-bind="attrs" v-on="on">
												mdi-information-outline
											</v-icon>
											</template>
											<span>{{$t('farm.perimeterPointLongH')}}</span>
										</v-tooltip>
									</label>
									<v-text-field
										placeholder="Perimeter Point Longitude"
										outlined
										dense
										v-model.number="farm.periPointLng"
										:rules="[
											v => ( !v || validateLatLng(v)) || 'Invalid Longitude'
										]"
									></v-text-field>
								</v-col>
							</v-row>
						</template>
					</v-container>
				</v-card> -->
				
			<!-- NEW Farm Location & Size -->
				<v-card class="mt-5">
            		<v-container fluid>
          				<h3>{{$t('farm.farmLocationSize')}}</h3>
						<v-row 
							class="px-2 mt-4"
							v-if="farm.lat && farm.log">
							<v-col class="px-1 py-4" sm="6" md="6">
							<v-btn
								color="primary"
								dark
								depressed
								outlined
								@click="showGeofenceTool"
							>
								{{ $t("UPDATE GEOFENCE FOR THIS FARM") }}
							</v-btn>
							<!-- <p class="mt-2 red--text">Note: Geofence is required for Satellite Reports and to add zones.</p> -->
							</v-col>
						</v-row>
						<v-row class="mt-2">
							<v-col cols="12" sm="6" md="3">
							<label
								>{{ $t("Farm Location Address") }}<span>*</span></label
							>
							<v-text-field
								:rules="farmRules.address"
								readonly
								@click="showFarmLocation = true"
								id="dialog-link1"
								placeholder="Please click to choose location"
								outlined
								dense
								v-model="farm.address"
							>
							</v-text-field>
							</v-col>

							<v-col cols="12" sm="6" md="3">
							<label>{{$t('farm.country')}} <span>*</span>
								<v-tooltip top color="black" max-width="220">
								<template v-slot:activator="{ on, attrs }">
									<v-icon v-bind="attrs" v-on="on">
									mdi-information-outline
									</v-icon>
								</template>
								<span>{{$t('farm.countryH')}}</span>
								</v-tooltip>
							</label>
							<v-autocomplete
								:items="country"
								:placeholder="$t('farm.country')"
								outlined
								item-text="name"
								dense
								:loading="countryLoading"
								v-model="farm.country.id"
								item-value="id"
								@change="getStates()"
								:rules="farmRules.country"
							>
								<template v-slot:item="data">
								<template>
									<v-row no-gutters>
									<v-list-item-content>
										<v-list-item-title v-html="data.item.name"></v-list-item-title>
									</v-list-item-content>
									</v-row>
								</template>
								</template>
							</v-autocomplete>
							</v-col>
							
							<v-col cols="12" sm="6" md="3">
							<label>{{$t('farm.state')}}<span>*</span>
								<v-tooltip top color="black" max-width="220">
								<template v-slot:activator="{ on, attrs }">
									<v-icon v-bind="attrs" v-on="on">
									mdi-information-outline
									</v-icon>
								</template>
								<span>{{$t('farm.stateH')}}</span>
								</v-tooltip>
							</label>
							<v-autocomplete
								:items="state"
								:placeholder="$t('farm.state')"
								outlined
								item-text="name"
								dense
								:loading="stateLoading"
								v-model="farm.state.id"
								item-value="id"
								@change="getCity(farm.state.id)"
								:rules="farmRules.state"
							>
								<template v-slot:item="data">
								<template>
									<v-row no-gutters>
									<v-list-item-content>
										<v-list-item-title v-html="data.item.name"></v-list-item-title>
									</v-list-item-content>
									</v-row>
								</template>
								</template>
							</v-autocomplete>
							</v-col>

							<v-col cols="12" sm="6" md="3">
							<label>{{$t('farm.city')}} <span>*</span>
								<v-tooltip top color="black" max-width="220">
								<template v-slot:activator="{ on, attrs }">
									<v-icon v-bind="attrs" v-on="on">
									mdi-information-outline
									</v-icon>
								</template>
								<span>{{$t('farm.cityH')}}</span>
								</v-tooltip>
							</label>
							<v-autocomplete
								:items="city"
								:placeholder="$t('farm.city')"
								outlined
								:loading="cityLoading"
								item-text="name"
								dense
								v-model="farm.cityId"
								item-value="id"
								@change="setCity()"
								:rules="farmRules.city"
							>
								<template v-slot:item="data">
								<template>
									<v-row no-gutters>
									<v-list-item-content>
										<v-list-item-title v-html="data.item.name"></v-list-item-title>
									</v-list-item-content>
									</v-row>
								</template>
								</template>
							</v-autocomplete>
							</v-col>
							<v-col cols="12" sm="6" md="3">
								<label>{{$t('farm.street')}} 
								<v-tooltip top color="black" max-width="220">
									<template v-slot:activator="{ on, attrs }">
									<v-icon v-bind="attrs" v-on="on">
										mdi-information-outline
									</v-icon>
									</template>
									<span>{{$t('farm.streetH')}}</span>
								</v-tooltip></label>
								<v-text-field
								:placeholder="$t('farm.street')"
								outlined
								dense
								v-model="farm.street"
								:rules="farmRules.street"
								></v-text-field>
							</v-col>

							<v-col cols="12" sm="6" md="3">
							<v-row no-gutters class="d-flex">
								<v-col cols="6" class="pr-1">
								<label>{{ $t("farm.totalFarmSize") }} </label>
								<v-text-field
									v-model="farm.farmSize"
									:placeholder="$t('e.g. 12 Hectors')"
									outlined
									dense
								></v-text-field>
								</v-col>
								<v-col cols="6">
								<label>{{ $t("Unit") }}</label>

								<v-select
									:items="farmUni"
									:placeholder="'Select'"
									v-model="farm.farmSizeUomId"
									outlined
									class="text-capitalize"
									item-text="name"
									item-value="id"
									dense
									@change="changeAreaUnit"
								>
								</v-select>
								</v-col>
							</v-row>
							</v-col>
							<v-col cols="12" sm="6" md="3">
							<v-row no-gutters class="d-flex">
								<v-col cols="6" class="pr-1">
								<label>{{ $t("farm.perimeterLength") }} </label>
								<v-text-field
									:placeholder="$t('farm.perimeterLength')"
									outlined
									dense
									v-model="farm.farmPerimeter"
								></v-text-field>
								</v-col>
								<v-col cols="6">
								<label>{{ $t("Unit") }}</label>
								<v-select
									v-model="farm.farmPerimeterUomId"
									:items="periUni"
									item-text="name"
									item-value="id"
									class="text-capitalize"
									:placeholder="$t('organizationNtrInfo.selectUnit')"
									outlined
									dense
								></v-select>
								</v-col>
							</v-row>
							</v-col>
							<v-col cols="12" sm="6" md="3">
							<label
								>{{ $t("farm.perimeterPointLabel") }}
								<v-tooltip top color="black" max-width="220">
								<template v-slot:activator="{ on, attrs }">
									<v-icon v-bind="attrs" v-on="on">
									mdi-help-circle-outline
									</v-icon>
								</template>
								<span>{{
									$t("farm.registration.perimeterPointLabel")
								}}</span>
								</v-tooltip></label
							>
							<v-text-field
								:placeholder="$t('farm.perimeterPointLabel')"
								outlined
								dense
								v-model="farm.periPointLabel"
							></v-text-field>
							</v-col>
							<v-col cols="12" sm="6" md="3">
							<label
								>{{ $t("farm.perimeterPointLatitude") }}
								<v-tooltip top color="black" max-width="220">
								<template v-slot:activator="{ on, attrs }">
									<v-icon v-bind="attrs" v-on="on">
									mdi-help-circle-outline
									</v-icon>
								</template>
								<span>{{
									$t("farm.registration.perimeterPointLatitude")
								}}</span>
								</v-tooltip></label
							>
							<v-text-field
								:placeholder="$t('farm.perimeterPointLatitude')"
								outlined
								dense
								v-model.number="farm.periPointLat"
								:rules="[
								(v) => !v || validateLatLng(v) || 'Invalid Latitude',
								]"
							></v-text-field>
							</v-col>
							<v-col cols="12" sm="6" md="3">
							<label
								>{{ $t("farm.perimeterPointLongitude") }}
								<v-tooltip top color="black" max-width="220">
								<template v-slot:activator="{ on, attrs }">
									<v-icon v-bind="attrs" v-on="on">
									mdi-help-circle-outline
									</v-icon>
								</template>
								<span>{{
									$t("farm.registration.perimeterPointLongitude")
								}}</span>
								</v-tooltip>
							</label>
							<v-text-field
								:placeholder="$t('farm.perimeterPointLongitude')"
								outlined
								dense
								v-model.number="farm.periPointLng"
								:rules="[
								(v) => !v || validateLatLng(v) || 'Invalid Longitude',
								]"
							></v-text-field>
							</v-col>
						</v-row>
            		</v-container>
          		</v-card>
			</div>
			<v-divider class="mt-2"></v-divider>
				<template>
					<div class="button mt-5 mb-5">
						<v-menu transition="scale-transition">
							<template v-slot:activator="{ on, attrs }">
								<v-btn
									outlined
									color="primary"
									:to="{ name: 'SingleFarm' }"
									v-bind="attrs"
									v-on="on"
								>
								{{$t('farm.cancel')}}
								</v-btn>
								<v-btn
									color="primary"
									dark
									v-bind="attrs"
									v-on="on"
									type="submit"
								>
								{{$t('farm.update')}}
								</v-btn>
							</template>
						</v-menu>
					</div>

					
        		</template>
      		</v-form>
	</v-container>
	<DataLostWarning
        :dialogI="dataLossWarning"
        v-if="dataLossWarning"
        @closeDialog="closeWarningMessage"
        @saveData="closeWarningMessage"  
      ></DataLostWarning>
	  <FarmLocation
      v-if="showFarmLocation"
      :showMap="showFarmLocation"
      :farm="farm"
      @close-location-modal="farmLocationClosed"
      @close-without-change="closeWithoutChange"
    />
    <PrimaryGeofence
      v-if="showMap"
      :showMap="showMap"
      :farm="farm"
      @close-location-modal="locationMapClosed"
      @close-without-change="closeWithoutChange"
    ></PrimaryGeofence>
  	</div>
</template>

<script>
import loadingMixin from "@/mixins/LoadingMixin";
import FarmService from "@/_services/farmService";
import Breadcrumb from "@/components/core/Breadcrumb";
import { farmRules } from "@/validations/FarmFormRules.js";
import FarmLocation from "./FarmLocation.vue";
import PrimaryGeofence from "./PrimaryGeofence.vue";
export default {
    async mounted() {
		await this.loadOptions();
		await this.getusers();
		await this.getItem();
		await this.getCountries();
		await this.geolocate();
  },
  	beforeRouteLeave(to, from, next) {
		if(this.formChanged) {
			this.promptToRoute = to;
			this.dataLossWarning = true;
			return
		}
		next();
	},
  components: {
        'breadcrumb': Breadcrumb,
		FarmLocation,
    	PrimaryGeofence
    },
  data() {
    return {
		showMap: false,
		showFarmLocation: false,
		address: "",
		selection: {
			country: null,
			state: null,
			city: null
      	},


		dataLossWarning: false,
		formChanged: false,
		promptToRoute: null,
      	today: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),
		menu: "",
		date:"",
		countryLoading:false,
		stateLoading:false,
		cityLoading:false,
		farm: { owner: { userNumber: null }},
		farmRules,
		valid: true,
		farmType: [],
		farmownershipType: [],
		productionSystem: [],
		production:"",
		res: [],
		items: ["foo", "bizz", "buzz"],
		country:[],
		state:[],
		city:[],
		ownerName:[],
		farmUni: [{ id: 1, name: 'Acre' }, { id: 2, name: 'Hectare' }],
		periUni: [{ id: 1, name: "Feet" }, { id: 2, name: "Meters" }],
		countryId: '',
		stateId: '',
		errors: {
			govRegistrationNo: ''
		},
      	breadcrumbs: [
            {
                text: this.$t('dashboard'),
                disabled: false,
                to:"/"
            },
            {
                text: this.$t('farm.farms'),
                link: true,
          		exact: true,
                disabled: false,
                to:{name:"My farm"}
            },
            {
                text: this.$t('farm.editAfarm'),
                disabled: true,
            },
        ],
    };
  },
  watch: {
    farm: {
      handler() {
        this.formChanged = true;
      },
      deep: true
    },
  },
  methods: {
	async setLocationAddresses() {
      	if (this.selection.country !== "") {
        	this.farm.country = this.country.filter((country) => {
          		return this.selection.country === country.name;
        	})[0] || {};

        if (typeof this.farm.country !== "string") {
          	await this.getStates(this.farm.country.id);

          	if (this.selection.state !== "") {
				this.farm.state = this.state.filter((state) => {
					return this.selection.state === state.name;
				})[0] || {};

            	if (typeof this.farm.state !== "string") {
              		await this.getCity(this.farm.state.id);

              		if (this.selection.city !== "") {
                		this.farm.city = this.city.filter((city) => {
                  			return this.selection.city === city.name;
					})[0] || {};

					if (typeof this.farm.city !== "string") {
						this.setCity();
					}
              }              
            } else {
              this.selection.city = this.farm.city;
            }
          }
        } else {
          this.selection.state = this.farm.state;
          this.selection.city = this.farm.city;
        }
      }
    },

	async farmLocationClosed(data) {
      this.showFarmLocation = false;
      this.farm.lat = data.lat;
      this.farm.log = data.log;
      this.farm.address = data.address;
      
      if (data.addressData) {
        this.selection.country = data.addressData.country;
        this.selection.city = data.addressData.locality;
        this.selection.state = data.addressData.administrative_area_level_1;
        this.selection.street = data.addressData.street_number
        this.selection.street = data.addressData.route;
      }

      await this.setLocationAddresses()
    },
	async locationMapClosed(gdata) {
      console.log(gdata, "locationMapClosed");

      this.showMap = false;
      this.farm.farmGeofence = gdata.farmGeofence;
      this.farm.farmSize = gdata.area;
      this.farm.farmPerimeter = +gdata.parameter;
      this.farm.farmSizeUomId = gdata.areaUomId;
      this.farm.farmPerimeterUomId = gdata.areaUomId; // 1 Acre = Feet, 2 Hac = Meter
    //   if (gdata.addressData) {
        // this.farm.country = gdata.addressData.country;
        // this.farm.city = gdata.addressData.locality;
        // this.farm.state = gdata.addressData.administrative_area_level_1;
        //this.farm.street = gdata.addressData.street_number
        // this.farm.street = gdata.addressData.route;
    //   }
      
    //   await this.setLocationAddresses();
    },
    closeWithoutChange() {
      this.showMap = false;
      this.showFarmLocation = false;
      // this.geofenceValidation = true
    },
	showGeofenceTool() {
      if (this.farm.lat !== "" && this.farm.log !== "") {
          this.showMap = true;
      } else {
          this.$notify({
            text: "Farm Location is required.",
            type: "error"
          });
      }
    },
	setCity() {
    //   if (this.selection.city === null) return;

    //   if (typeof this.farm.city !== "string") {
    //     this.selection.city = this.farm.city;
    //     return;
    //   }

      this.farm.cityId = this.farm.city.id || null;
    },
	changeAreaUnit() {
      if (this.farm.farmSizeUomId === 1) {
        this.farm.farmSize = parseFloat(this.farm.farmSize * 2.47105).toFixed(5);
      } else {
        this.farm.farmSize = parseFloat(this.farm.farmSize / 2.47105).toFixed(5);
      }
    },

	closeWarningMessage(stay) {
      this.dataLossWarning = false;
      if(!stay) {
        this.formChanged = false;
        this.$router.push(this.promptToRoute)
      }
    },
	validateLatLng(latLng) {
		var reg = new RegExp("^-?([1-8]?[1-9]|[1-9]0)\\.{1}\\d{1,6}");
		if( reg.exec(latLng) ) {
			return true;
		} else {
			return false;
		}
	},
	cityChanged(e) {
		this.farm.cityId = e;
		this.farm.city.id = e;
		alert(JSON.stringify(this.farm.cityId))
	},
    loadOptions() {
      const options = {
        options: ["production-system", "farm-ownership-type", "farm-type"],
      };
      FarmService.loadoptions(options).then((data) => {
        let newdata = data.data["production-system"];
        this.productionSystem = newdata;
        let ownerdata = data.data["farm-ownership-type"];
        this.farmownershipType = ownerdata.map((item) => item.name);
        let farmdata = data.data["farm-type"];
        this.farmType = farmdata.map((item) => item.name);
      });
    },
    getusers(){
      FarmService.loadUsers().then((data) => {
        console.log(data.data.users);
        this.ownerName=data.data.users
      });
    },
    getCountries() {
        this.countryLoading=true
      FarmService.loadCountries().then((data) => {
        this.country = data.data;
        this.countryLoading=false
      });

    },
    async getStates(id) {
      // this.stateLoading=true
      this.countryId = id;
	  this.city=[];
      return FarmService.loadStates(this.countryId).then((data) => {
        this.state = data.data.length!==0 ? data.data:[{id:"0",name:"No state available"}];
        //  this.StateLoading=false
		return Promise.resolve()
      });
    },
    async getCity(id) {
		this.cityLoading=true
		if(id==null){
			this.stateId=345
		}else{
			this.stateId = id;
		}
		console.log(this.stateId);
		return FarmService.loadCities(this.stateId)
		.then((data) => {
			this.city = data.data.length!==0 ? data.data:[{id:"0",name:"No city available"}];
			this.cityLoading=false
			return Promise.resolve()
		});
    },
    geolocate() {
      navigator.geolocation.getCurrentPosition((position) => {
        this.farm.lat = position.coords.latitude;
        this.farm.log = position.coords.longitude;
      });
    },
    getItem() {
      	this.startLoading()
      	FarmService.getfarm(this.$route.params.id)
		.then(async(data) => {
			this.farm = data;
			if (!this.farm.owner || !this.farm.owner.userNumber) {
				this.farm.owner = { userNumber: this.farm.ownerId }
			}

			if(this.farm.coordinates && this.farm.coordinates.length > 0) {
				this.farm.farmGeofence = this.farm.coordinates.map(coord => coord)
			}

			if (data.owner && data.owner.name) {
				this.farm.ownerId = data.owner.name;
			}
			if(!this.farm.productionSystem) {
				console.log('sss')
				this.farm.productionSystem = {}
			}
			await this.getStates(this.farm.country.id);
			await this.getCity(this.farm.state.id);
			this.stopLoading()
		});
	},
    updateFarm() {
      this.farm.productionSystemOptId=this.farm?.productionSystem?.id
      // this.farm.ownerId=this.farm.owner && this.farm.owner.userNumber ? this.farm.owner.userNumber : this.farm.ownerId
      
      this.farm.countryId=this.farm.country.id
      this.farm.stateId=this.farm.state.id
      // this.farm.cityId=this.farm.city!==null?this.farm.city.id:0
      if (!this.$refs.form.validate()) return;
	  this.formChanged = false;
      this.startLoading()
      FarmService.editfarm(this.farm).then((res) => {
        // console.log(res); 
        if (res.success==true) {
           this.stopLoading() 
		   this.$router.push({ name: "SingleFarm", params: { id: this.$route.params.id } });
            this.$notify({
              title: 'Farm Updated',
              text: res.message,
              type: 'success'
            });
          }else{
            this.$notify({
              title: 'Farm Not Updated',
              text: res.message,
              type: 'error'
              });
          }
      })
       .catch((error) => {
		   if (error.status == 422) {
			    console.log(error);
				error.data.message.errors.forEach((err) => {
				this.errors[err.param] = err.msg;
				});
          }
          this.stopLoading()
        });
    },
  },
  mixins: [loadingMixin],
};
</script>

<style >
.page-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 0px 0px 15px;
}

.search-box-section .align-section {
  align-items: center;
  display: flex;
  font-size: 15px;
  color: #555;
}
.page-details-search {
  display: flex;
  justify-content: space-between;
}
.page-details-search {
  display: flex;
  justify-content: space-between;
}
.button {
  float: right;
}
.v-btn {
  margin-right: 5px;
}
.route {
  text-decoration: none !important;
}
.form-section label {
  display: inline-block;
  margin-bottom: 0.5rem;
  /* color: #97A8B8; */
  font-size: 14px;
  font-family: Poppins-Medium;
  letter-spacing: 0.5px;
  white-space: nowrap;
}
.v-list-item__title{
  text-transform: capitalize;
}
/* .v-col.v-subheader{
  font-weight: bold;
} */

#dialog-link1 {
  cursor: pointer !important;
}

#dialog-link1::placeholder {
  color: #002287 !important;
  text-decoration: underline !important;
}
</style>